import dayjs from 'dayjs';

import {
  SETTLEMENTS_CADENCE_VALUES,
  SETTLEMENT_OFFER_TYPES,
} from 'utilities/constants';

import EstimatedPayments from './EstimatedPayments';
import {
  RECOVERIES_STEPS,
  setNextStep,
  setPaymentDates,
  setPaymentPlan,
  useRecoveriesState,
} from './recoveriesState';
import PaymentPlanForm from '../PaymentPlanForm';

const PaymentPlanDetailsStep = () => {
  const { offer, paymentDates, paymentPlan } = useRecoveriesState();
  const isPifOffer = offer?.offerType === SETTLEMENT_OFFER_TYPES.PIF;

  const handlePaymentDetails = ({ cadence, startDate, duration }) => {
    setPaymentPlan({ ...paymentPlan, cadence, planDuration: duration });
    if (startDate) {
      const endDate = dayjs().add(duration, 'month');
      setPaymentDates(dayjs(startDate).format('L'), endDate.format('L'));
    }
  };

  const handleSchedule = (schedule) => {
    setPaymentPlan({ cadence: paymentPlan.cadence, current: schedule });
  };

  return (
    <PaymentPlanForm
      formName="paymentDetailsForm"
      initialCadence={paymentPlan.cadence}
      initialStartDate={paymentDates.startDate}
      initialDuration={
        isPifOffer ? (paymentPlan.planDuration ?? offer.duration) : null
      }
      balance={offer.balance.settlementBalance}
      expirationDate={offer.expiration}
      maxDurationMonths={offer.duration}
      durationLabel={
        isPifOffer
          ? 'Enter Plan Duration (in months)'
          : 'Enter Payment Schedule Duration'
      }
      durationRequired={isPifOffer}
      showDurationField={(c) => c != SETTLEMENTS_CADENCE_VALUES.ONE_TIME}
      setPaymentDetails={handlePaymentDetails}
      setSchedule={handleSchedule}
      onSubmit={() => setNextStep(RECOVERIES_STEPS.FINALIZE_PAYMENT_PLAN)}
      renderEstimatedPayments={(queryLoading) => (
        <EstimatedPayments loadingQuery={queryLoading} />
      )}
    />
  );
};

export default PaymentPlanDetailsStep;
